import React from 'react';
import cx from 'clsx';
import { parseHighlightedText } from './parse-highlighted-text.ts';
import styles from './text-with-highlights.module.css';

interface TextWithHighlightsProps {
  children: string;
  isHighlighted?: boolean;
}

export function TextWithHighlights({
  isHighlighted = true,
  children,
}: TextWithHighlightsProps): React.ReactNode {
  return (
    <span>
      {parseHighlightedText(children).map((part, index) => (
        <span
          className={cx(part.isHighlight && isHighlighted && styles.highlightedText)}
          // oxlint-disable-next-line react/no-array-index-key -- Static, OK to use index
          key={index}
        >
          {part.text}
        </span>
      ))}
    </span>
  );
}
